import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import DatePicker from 'material-ui/DatePicker';
import CircularProgress from 'material-ui/CircularProgress';

import {
  changeState,
  updateProfession,
  updateSettings
} from '../actions/index';

import { CONSTANTS, ASSET_PREFIX } from '../config/constants';
import QbankButton from '../components/QbankButton';
import '../styles/FirstRun.css';

const styles = {
  button: { width: '200px', height: '45px' }
};

class FirstRun extends Component {
  constructor(props) {
    super(props);

    this.state = {
      exam: null,
      date: null,
      specialty: null,
      profession: null,
      loading: false
    };

    this.saveFirstRunSettings = this.saveFirstRunSettings.bind(this);
  }

  saveFirstRunSettings() {
    const exam =
      this.state.exam &&
      this.state.date &&
      !(
        this.state.exam ===
        CONSTANTS.EXAM_TYPES[ASSET_PREFIX[this.props.product].toUpperCase()].NA
      );
    const examDate = exam
      ? new Date(this.state.date)
          .toISOString()
          .split('T')[0]
          .concat(' 00:00:00')
      : null;
    this.setState({ loading: true });
    Promise.all([
      this.props.updateProfession(this.state.profession),
      exam
        ? this.props.updateSettings(
            CONSTANTS.FIRST_RUN_FIELDS.EXAM_TYPE,
            this.state.exam,
            CONSTANTS.FIRST_RUN_FIELDS.EXAM_DATE,
            examDate
          )
        : this.props.updateSettings(
            CONSTANTS.FIRST_RUN_FIELDS.SPECIALTY,
            this.state.specialty
          )
    ])
      .then(res => this.props.changeState('settings', { firstRun: 1 }))
      .catch(err => {
        console.log(err);
        //TODO HANDLE ERROR
      });
  }

  render() {
    const check = this.props.product
      ? require(`../images/${
          ASSET_PREFIX[this.props.product]
        }-circle-check@3x.png`)
      : null;
    const canSave =
      ((this.state.exam &&
        this.state.date &&
        !(
          this.state.exam ===
          CONSTANTS.EXAM_TYPES[ASSET_PREFIX[this.props.product].toUpperCase()]
            .NA
        )) ||
        this.state.specialty) &&
      this.state.profession;

    return (
      <div className="first-run">
        <div className="first-run-header">
          <img alt="" src={check} />
        </div>
        <div className="first-run-title">
          <p>First, tell us a little about yourself.</p>
        </div>
        <p className="first-run-menu-title">What are you preparing for?</p>
        <div className="exam-menus first-run-drop-div">
          <SelectField
            hintText="I'm preparing for..."
            className="exam-dropdown-menu"
            value={this.state.exam}
            onChange={(e, i, val) => {
              this.setState({ exam: val });
            }}
          >
            {Object.keys(
              CONSTANTS.EXAM_TYPES[
                ASSET_PREFIX[this.props.product].toUpperCase()
              ]
            ).map((exam, i) => (
              <MenuItem
                key={i}
                value={
                  CONSTANTS.EXAM_TYPES[
                    ASSET_PREFIX[this.props.product].toUpperCase()
                  ][exam]
                }
                primaryText={
                  CONSTANTS.EXAM_TYPES[
                    ASSET_PREFIX[this.props.product].toUpperCase()
                  ][exam]
                }
              />
            ))}
          </SelectField>
          <div
            className="fr-menu-wrapper"
            style={
              this.state.exam ===
              CONSTANTS.EXAM_TYPES[
                ASSET_PREFIX[this.props.product].toUpperCase()
              ].NA
                ? { height: 0 }
                : {}
            }
          >
            <DatePicker
              autoOk
              hintText={
                this.state.date ? this.state.date.toString() : 'Exam Date'
              }
              disabled={
                this.state.exam ===
                CONSTANTS.EXAM_TYPES[
                  ASSET_PREFIX[this.props.product].toUpperCase()
                ].NA
              }
              shouldDisableDate={day => day <= new Date()}
              onChange={(e, date) => this.setState({ date })}
            />
          </div>
        </div>
        <div
          className="fr-menu-wrapper"
          style={
            this.state.exam ===
            CONSTANTS.EXAM_TYPES[ASSET_PREFIX[this.props.product].toUpperCase()]
              .NA
              ? {}
              : { height: 0 }
          }
        >
          <p className="first-run-menu-title">What is your specialty?</p>
          <div className="first-run-drop-div">
            <SelectField
              hintText="Specialty"
              className="first-run-dropdown-menu"
              value={this.state.specialty}
              onChange={(e, i, val) => {
                this.setState({ specialty: val });
              }}
            >
              {Object.keys(CONSTANTS.SPECIALTIES).map((title, i) => (
                <MenuItem
                  key={i}
                  value={CONSTANTS.SPECIALTIES[title]}
                  primaryText={CONSTANTS.SPECIALTIES[title]}
                />
              ))}
            </SelectField>
          </div>
        </div>
        <p className="first-run-menu-title">What is your training level?</p>
        <div className="first-run-drop-div">
          <SelectField
            hintText="Training Level"
            className="first-run-dropdown-menu"
            value={this.state.profession}
            onChange={(e, i, val) => {
              this.setState({ profession: val });
            }}
          >
            {this.props.profs
              .sort(
                (b, a) =>
                  this.props.product ===
                    'a735b689-e6d0-419b-b785-76fe33f86f3d' && a.title === 'PA'
                    ? 1
                    : this.props.product ===
                        'a735b689-e6d0-419b-b785-76fe33f86f3d' &&
                      a.title === 'PA Student'
                      ? 1
                      : -1
              )
              .map(prof => (
                <MenuItem value={prof.id} primaryText={prof.title} />
              ))}
          </SelectField>
        </div>
        {this.state.loading || !this.props.tags.length ? (
          <CircularProgress size={60} thickness={7} color="#95BF5E" />
        ) : (
          <QbankButton
            label="SAVE AND CONTINUE"
            style={styles.button}
            onClick={this.saveFirstRunSettings}
            disabled={!canSave}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    product: state.app.product,
    profs: state.app.profs || [],
    settings: state.app.settings || { values: {} },
    user: state.app.user,
    isTrial: state.app.user.isTrial,
    tags: state.tags || [],
    features: state.app.newFeatures
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { changeState, updateProfession, updateSettings },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(FirstRun);



// WEBPACK FOOTER //
// ./src/containers/FirstRun.js